
import Vue from "vue"
import Preview from '@/components/preview/index.vue'
import Aside from './index.vue'
export default Vue.extend({
  components:{
	Preview,
	Aside
  }
})
